<template>
  <div class="statistics">
    <!-- <header>
      <button @click="goback" style="cursor:pointer" class="retbtn">
        <i class="el-icon-back"></i>
      </button>
    </header> -->
    <div class="main">
      <i class="el-icon-arrow-left" @click="goback"></i>
      <template>
        <el-tabs v-model="activeName" @tab-click="handleClick">

          <el-tab-pane label="统计面板" name="StatisticsPanel">
            <StatisticsPanel v-if="activeName==='StatisticsPanel'" />
          </el-tab-pane>

          <el-tab-pane label="生产报表" name="ProductionReport">
            <ProductionReport v-if="activeName==='ProductionReport'" />
          </el-tab-pane>

          <el-tab-pane :label="label" name="InterpreterPerformance">
            <InterpreterPerformance v-if="activeName==='InterpreterPerformance'" />
          </el-tab-pane>

          <el-tab-pane v-if="!this.$independence" :label="interpreterLab" name="InterpreterStatistics">
            <InterpreterStatistics v-if="activeName==='InterpreterStatistics'" />
          </el-tab-pane>

        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
import StatisticsPanel from "@/common/Statistics/StatisticsPanel";
import ProductionReport from "@/common/Statistics/ProductionReport";
import InterpreterPerformance from "@/common/Statistics/InterpreterPerformance";
import InterpreterStatistics from '@/common/Statistics/InterpreterStatistics'
export default {
  data() {
    return {
      activeName: "StatisticsPanel",
      label: "译员业绩",
      interpreterLab: "译员统计"
    };
  },
  components: { StatisticsPanel, ProductionReport, InterpreterPerformance, InterpreterStatistics },
  created() {
    this.activeName = this.$route.params.activeName || "StatisticsPanel";
    if (process.env.VUE_APP_NAME === "school") {
      this.label = "学生业绩"
    }
  },
  methods: {
    // 回退
    goback() {
      this.$router.go(-1)
    },
    handleClick(tab, event) {
      if (tab.name == "information") {
      }
    },
  },



};
</script>
<style lang="less" scoped>
.statistics {
  height: 100%;
  header {
    display: flex;
    line-height: 30px;
    p {
      margin-left: 5px;
    }
    .retbtn {
      width: 48px;
      height: 30px;
      background: #02a4fd;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 2px;
      margin-left: 20px;
      .el-icon-back {
        font-size: 18px;
        color: white;
      }
    }
  }
  .main {
    height: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    padding: 0 20px;
    .el-icon-arrow-left {
      float: left;
      position: relative;
      top: 24px;
      left: -6px;
      cursor: pointer;
      z-index: 10;
    }
    /deep/.el-tabs {
      height: 100%;
      padding-top: 12px;
      box-sizing: border-box;
      .el-tab-pane {
        height: 100%;
      }
    }
    /deep/.el-tabs__content {
      height: calc(100% - 55px);
    }
    /deep/.el-tabs__nav-wrap::after {
      background: #e2e9f3;
    }
  }
}
</style>
